import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import axiosInstance from "../../axiosInstance";
import ConfirmationDialog from "../ConfirmationDialog/ConfirmationDialog";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "react-bootstrap/Spinner";

import "./GeoFences.css";

const GeoFences = () => {
  const [geoFences, setGeoFences] = useState([]);
  const [trackName, setTrackName] = useState(""); // State for track name
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();
  const location = useLocation(); // React Router's location hook
  const [showDialog, setShowDialog] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({
    title: "",
    bodyText: "",
    confirmText: "",
    cancelText: "",
    onConfirm: () => {},
  });

  useEffect(() => {
    const trackId = new URLSearchParams(location.search).get("trackId");
    if (trackId) {
      fetchTrackName(trackId);
    }
    fetchGeoFences(trackId);
  }, [location.search]); // Re-fetch whenever query parameters change

  const fetchTrackName = async (trackId) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.get(`/track/${trackId}`, {
        headers: {
          Authorization: token,
        },
      });

      if (response.status === 200 && response.data.success) {
        setTrackName(response.data.data.trackName);
      } else {
        setTrackName("Track Not Found");
      }
    } catch (error) {
      console.error("Error fetching track name:", error);
      setTrackName("Track Not Found");
    }
  };

  const fetchGeoFences = async (trackId) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.get("/geofence", {
        headers: {
          Authorization: token,
        },
      });

      if (response.status === 200 && response.data.success) {
        const allGeoFences = response.data.data;

        // Filter GeoFences based on trackId
        const filteredGeoFences = trackId
          ? allGeoFences.filter(
              (geoFence) => geoFence.trackId === parseInt(trackId)
            )
          : allGeoFences;

        setGeoFences(filteredGeoFences);
        setError(null);
      } else {
        setError(response.data.error?.message || "GeoFences Not Found.");
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setError("GeoFences Not Found.");
      } else {
        setError("Failed to fetch GeoFences. Please try again.");
      }
      console.error("Error fetching GeoFences:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddGeoFence = () => {
    history.push("/add-geo-fences");
  };

  const handleDeleteGeoFence = (id, e) => {
    e.stopPropagation();
    setDialogConfig({
      title: "Delete GeoFence?",
      bodyText: "Are you sure you want to delete this GeoFence?",
      confirmText: "Delete",
      cancelText: "Cancel",
      onConfirm: () => confirmDeleteGeoFence(id),
    });
    setShowDialog(true);
  };

  const confirmDeleteGeoFence = async (id) => {
    const token = localStorage.getItem("token");
    try {
      await axiosInstance.delete(`/geofence/${id}`, {
        headers: {
          Authorization: token,
        },
      });
      toast.success("GeoFence deleted successfully");
      fetchGeoFences();
      handleCloseDialog();
    } catch (error) {
      console.error("Error deleting GeoFence:", error);
      toast.error("Failed to delete GeoFence");
    }
  };

  const handleCloseDialog = () => setShowDialog(false);

  const handleUpdateGeoFence = (id) => {
    history.push(`/geofence/${id}`);
  };

  const renderGeoFences = () => {
    if (error) {
      return (
        <div
          className="text-center w-100"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "20px",
          }}
        >
          {error}
        </div>
      );
    }

    if (geoFences.length > 0) {
      return (
        <>
          {geoFences.map((geoFence, index) => (
            <Col
              key={index}
              xs={12}
              md={4}
              className="mb-3"
              onClick={() => handleUpdateGeoFence(geoFence.geoFenceId)}
            >
              <div className="track-card">
                <div style={{ height: "200px", marginBottom: "10px" }}>
                  <img
                    src={
                      geoFence.track?.mapImage || "/img/Map/Default-Map.png"
                    }
                    alt={geoFence.track?.trackName || "No Track Name"}
                    style={{
                      height: "100%",
                      marginBottom: "10px",
                      width: "100%",
                      objectFit: "unset",
                    }}
                  />
                </div>
                <div className="track-info">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>{geoFence.geoMapName || "Unnamed Geo Map"}</h5>
                    <button
                      className="btn btn-danger"
                      onClick={(e) => {
                        handleDeleteGeoFence(geoFence.geoFenceId, e);
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </div>
                  <div className="track-meta">
                    <span
                      className="clickable-meta"
                      onClick={(e) => {
                        e.stopPropagation();
                        history.push(`/races?geoFenceId=${geoFence.geoFenceId}`);
                      }}
                    >
                      {geoFence.races?.length ?? 0} Races
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </>
      );
    }

    return (
      <div
        className="text-center w-100"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "20px",
        }}
      >
        No GeoFences found
      </div>
    );
  };

  return (
    <>
      <ContentWrapper>
        <Container fluid className="pb-0">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Geo Fences</Breadcrumb.Item>
          </Breadcrumb>
          <h4 className="mb-4 text-center tck_name">{trackName || "Geo Fences"}</h4>
          {loading ? (
            <Row
              className="text-center w-100"
              style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner animation="border" />
            </Row>
          ) : (
            <>
              <Row className="mb-3" id="mb-rw">
                {renderGeoFences()}
              </Row>
              <Row className="mb-3">
                <Col xs={12} className="d-flex justify-content-start">
                  <button
                    className="btn btn-primary sv_btn"
                    onClick={handleAddGeoFence}
                  >
                    + Add New GeoFence
                  </button>
                </Col>
              </Row>
            </>
          )}
        </Container>
        <ThinFooter />
      </ContentWrapper>
      <ConfirmationDialog
        show={showDialog}
        onClose={handleCloseDialog}
        title={dialogConfig.title}
        bodyText={dialogConfig.bodyText}
        confirmText={dialogConfig.confirmText}
        cancelText={dialogConfig.cancelText}
        onConfirm={dialogConfig.onConfirm}
      />
      <Toaster />
    </>
  );
};

export default GeoFences;
